import './index.scss';
import React, { useEffect, useRef, useState } from 'react';
import useResize from '~/hooks/useResize';
const ResponsiveItem = (props) => {
    const { children, onClick, fontSize, overflowText, wrapperClassName } = props;
    const cellRef = useRef(null);
    const textRef = useRef(null);
    const { width: cellWidth } = useResize(cellRef);
    const { width: textWidth, handleResize: handleTextWidthResize } = useResize(textRef);
    const [textExceedingCellWidth, setTextExceedingCellWidth] = useState(false);
    useEffect(() => {
        if (textWidth && cellWidth) {
            setTextExceedingCellWidth(textWidth > cellWidth);
        }
    }, [cellWidth, textWidth]);
    useEffect(() => {
        handleTextWidthResize();
    }, [handleTextWidthResize, overflowText]);
    const childWrapperClass = (`${wrapperClassName}${typeof children === 'string' ? ' overflow-ellipsis' : ''}`);
    return (React.createElement("div", { className: 'responsive-item-wrapper', onClick: onClick, ref: cellRef },
        React.createElement("div", { className: 'hidden-inline-block', ref: textRef, style: fontSize ? { fontSize } : {} }, overflowText),
        React.createElement("div", { className: childWrapperClass, title: textExceedingCellWidth ? overflowText : '' }, children)));
};
export default ResponsiveItem;
